export const REEL_CONFIG_KEYS_BY_SECTION = {
  HOSE: ['nWrapsOuterLayer', 'hoseDiameterMm', 'outerHoseWrapRadiusMm'],
  NOZZLE: ['nozzleDiameterMm', 'nNozzles', 'sprinklerType', 'swathWidthMm'],
  SPOOL: ['widthMm', 'nMagnets']
} as const;

export type ReelConfigSectionKey = keyof typeof REEL_CONFIG_KEYS_BY_SECTION;
export type ReelConfigKeysBySection = typeof REEL_CONFIG_KEYS_BY_SECTION;
